<h2 mat-dialog-title>
  @if (createNew) {
    <span>Opret ny standard søjlevisning</span>
  }
  @if (!createNew) {
    <span>Rediger "{{display.name}}" søjlevisning</span>
  }
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <div fxFlex fxLayout="column" [formGroup]="form">
    <mat-form-field>
      <!--       Todo: Check for dublicate-->
      <mat-label>Navn på visning</mat-label>
      <input type="text" matInput formControlName="name" required>
    </mat-form-field>

    <div fxFlex fxLayoutAlign="space-between">
      <div fxFlex="45">
        <p>Ledige søjler</p>
        <div class="example-list">
          @for (field of availableFields; track field; let i = $index) {
            <div class="example-box" (click)="addField(field, i)">
              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
              {{'fields.' + field.key | translate}}
              <button mat-icon-button>
                <mat-icon>add</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
      <div fxFlex="45" >
        <p>Valgte søjler</p>
        <div class="example-list" cdkDropList (cdkDropListDropped)="drop($event)">
          @for (field of chosenFields; track field; let i = $index) {
            <div class="example-box moveable" cdkDrag>
              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
              <button mat-icon-button><mat-icon>drag_indicator</mat-icon></button>
              {{'fields.' + field.key | translate}}
              <button mat-icon-button (click)="removeField(field, i)">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          }
        </div>

      </div>
    </div>

    <div formArrayName="fields_sorting">
      @for (_ of 3 | fill; track _; let i = $index) {
        <app-fields-sorting
          [sortingNumber]="i"
          [chosenSortingFields]="fieldsSortingArray"
          [availableSortingFields]="availableSortingFields"
          (addSorting)="addSorting($event)"
          (removeSorting)="removeSorting($event)"
        ></app-fields-sorting>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid || chosenFields.length === 0">Gem</button>
</mat-dialog-actions>
